import { useState } from 'react';
import { toast } from 'react-toastify';
import { formatImageUrl } from '../../../shared/utils/formatImageUrl';
import { ImageCropper } from '../../../shared/ui/ImageCropper/ImageCropper';
import './UploadIcon.css';

export const UploadIcon = ({
  onSelect,
  className = '',
  initialIcon = null,
  entityType = 'icon',
}) => {
  const [icon, setIcon] = useState(initialIcon);
  const [showCropper, setShowCropper] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Проверка типа файла
    if (!file.type.includes('image/')) {
      toast.error('Пожалуйста, загрузите изображение');
      return;
    }

    // Проверка размера файла (не более 1MB)
    if (file.size > 1024 * 1024) {
      toast.error('Размер иконки не должен превышать 1MB');
      return;
    }

    // Создаем URL для предпросмотра и открываем кроппер
    const previewUrl = URL.createObjectURL(file);
    setSelectedFile(previewUrl);
    setShowCropper(true);
  };
  
  // Обработчик завершения кадрирования
  const handleCropComplete = (cropResult) => {
    if (cropResult && cropResult.blob) {
      // Устанавливаем кадрированное изображение для предпросмотра
      setIcon(cropResult.croppedImageUrl);
      
      // Передаем blob родительскому компоненту
      onSelect(cropResult.blob);
      
      // Закрываем кроппер
      setShowCropper(false);
    }
  };

  return (
    <div className={`upload-icon ${className}`}>
      <label className="form-label">Иконка</label>
      <div className="icon-upload-container">
        {icon && (
          <div className="icon-preview">
            <img
              src={
                typeof icon === 'string'
                  ? icon.startsWith('blob:')
                    ? icon
                    : formatImageUrl(icon)
                  : URL.createObjectURL(icon)
              }
              alt="Icon preview"
              className="icon-image"
            />
          </div>
        )}
        <label className="icon-upload-button">
          <input
            type="file"
            accept="image/png, image/jpeg, image/svg+xml"
            onChange={handleFileChange}
            className="d-none"
          />
          <span className="at-btn at-btn-small">
            {icon ? 'Изменить иконку' : 'Загрузить иконку'}
          </span>
        </label>
      </div>
      <small className="text-muted">Рекомендуемый размер: 32x32px. Форматы: PNG, JPEG, SVG</small>
      
      {/* Компонент кадрирования */}
      <ImageCropper
        image={selectedFile}
        show={showCropper}
        onHide={() => setShowCropper(false)}
        onCropComplete={handleCropComplete}
        aspectRatio={1} // Квадратная иконка по умолчанию
      />
    </div>
  );
};
